import React from 'react';
import _ from 'lodash';
import { observer } from 'mobx-react';
import type MarginType from '@this/domain/organization/margin_type2';

interface Props {
  marginType: MarginType;
}

const MarginTypeForm: React.FC<Props> = ({ marginType }) => {
  return (
    <>
      <label>{marginType.categoryText}</label>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            marginBottom: '10px',
            marginRight: '10px',
            padding: '4px 8px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
            minHeight: '24px'
          }}
        >
          {marginType.baseTypeText}
        </div>
        <div
          style={{
            padding: '4px 8px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
            minHeight: '24px'
          }}
        >
          {marginType.baseAmount || ''}
        </div>
      </div>
    </>
  );
};

export default observer(MarginTypeForm);
